// Mobile drill-down menu (header "Mobile menu style" = Drill-down; markup in
// snippets/nav-drilldown-mobile.liquid). The drawer itself is still opened and closed
// by the compiled megamenu.js; this only slides the pre-rendered panels.
(function () {
  var root = document.querySelector('[data-mdd]');
  if (!root) return;

  var panels = {};
  root.querySelectorAll('[data-mdd-panel]').forEach(function (panel) {
    panels[panel.getAttribute('data-mdd-panel')] = panel;
  });
  var stack = ['root'];

  function setState(panel, state) {
    panel.classList.toggle('is-active', state === 'active');
    panel.classList.toggle('is-left', state === 'left');
    if (state === 'active') {
      panel.removeAttribute('aria-hidden');
      panel.inert = false;
    } else {
      panel.setAttribute('aria-hidden', 'true');
      panel.inert = true;
    }
  }

  function show(name) {
    var next = panels[name];
    if (!next) return;
    setState(panels[stack[stack.length - 1]], 'left');
    next.scrollTop = 0;
    setState(next, 'active');
    stack.push(name);
    var backButton = next.querySelector('[data-mdd-back]');
    if (backButton) backButton.focus({ preventScroll: true });
  }

  function back() {
    if (stack.length < 2) return;
    var current = panels[stack.pop()];
    var previous = panels[stack[stack.length - 1]];
    setState(current, 'right');
    setState(previous, 'active');
    var opener = previous.querySelector('[data-mdd-open="' + current.getAttribute('data-mdd-panel') + '"]');
    if (opener) opener.focus({ preventScroll: true });
  }

  function reset() {
    stack = ['root'];
    Object.keys(panels).forEach(function (name) {
      setState(panels[name], name === 'root' ? 'active' : 'right');
      panels[name].scrollTop = 0;
    });
  }

  root.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-mdd-open]');
    if (opener) {
      show(opener.getAttribute('data-mdd-open'));
      return;
    }
    if (event.target.closest('[data-mdd-back]')) back();
  });

  // Swipe right to go back a level.
  var startX = null;
  var startY = null;
  root.addEventListener(
    'touchstart',
    function (event) {
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    },
    { passive: true }
  );
  root.addEventListener(
    'touchend',
    function (event) {
      if (startX === null) return;
      var dx = event.changedTouches[0].clientX - startX;
      var dy = event.changedTouches[0].clientY - startY;
      startX = null;
      if (dx > 60 && Math.abs(dy) < 40) back();
    },
    { passive: true }
  );

  // Reopen at the top level after the drawer closes.
  var drawer = document.getElementById('MobileNav');
  if (drawer) {
    new MutationObserver(function () {
      if (!drawer.classList.contains('show')) reset();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  reset();
})();
